import React from 'react';

interface Props {
    onClick?: (menuKey: string) => void;
    url?: string;
    menukey: string;
    className: string;
    prefixIcon?: React.ReactNode;
    suffixIcon?: React.ReactNode;
}
export default class PaneMenuItem extends React.PureComponent<Props, {}> {
    static defaultProps = {
        className: '',
    };

    handleClick = (evt: React.MouseEvent): void => {
        const { onClick, url, menukey } = this.props;

        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();

        if (onClick) {
            onClick(menukey);
        }

        if (url) {
            // @ts-ignore
            window.location = url;
        }
    };

    render() {
        const { children, prefixIcon, suffixIcon, className } = this.props;

        let classNames: Array<string> = ['ct-pane-menu__item', className];

        return (
            <div className={classNames.join(' ')} onClick={this.handleClick}>
                <div className="ct-pane-menu__item-prefix">{prefixIcon}</div>
                <div className="ct-pane-menu__item-label">{children}</div>
                <div className="ct-pane-menu__item-suffix">{suffixIcon}</div>
            </div>
        );
    }
}
